// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\StandardItemType\ApiStandardItemType.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { StandardItem, StandardItemData, StandardItemOptions } from 'data/models/StandardItem';

// StandardItemTypeData is the class that StandardItemType serializes to/from
export interface StandardItemTypeData {
    Id : /* GUID */ string;
	
    Items : StandardItemData[] | null;
	
    Name : string | null;
}

// StandardItemTypeOptions is the class which may be passed to the StandardItemType constructor to define optional initial data values
export interface StandardItemTypeOptions {
    Id : /* GUID */ string;
	
    Items? : StandardItemOptions[] | null;
	
    Name? : string | null;
}

export class StandardItemType {
    public Id : DataSignal<string>;
	
    public Items : SDataArray<StandardItem>;
	
    public Name : DataSignal<string | null>;

    constructor();
    constructor(data : StandardItemTypeOptions);
    constructor(data: StandardItemTypeOptions | null = null) {
        this.Id = jsonableObservable(S.value<string>(data && data.Id !== undefined ? data.Id : '00000000-0000-0000-0000-000000000000'));
	    
        this.Items = SArray<StandardItem>([]);
	    
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
    }

    static key(obj : StandardItemType) {
        return obj.Id();
    }
    
    static dataKey(obj : StandardItemTypeOptions) {
        return obj.Id;
    }

    static update(obj : StandardItemType, data : StandardItemTypeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.Name !== undefined) obj.Name(data.Name);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/StandardItemType.ts